import React from 'react'
import Background from 'components/Background'

const FourOFourBackground = () => (
  <Background height="38vh" />
)
export default FourOFourBackground
